import React from "react";
import { StyledList } from "components/molecules/SummaryList/SummaryList.styles";
export default function SummaryList({ inputs }) {
  return (
    <StyledList>
      {inputs &&
        inputs.map((field) => (
          <li key={field.id}>
            {field.label}{" "}
            {field.unit === "PLN" || field.unit === "EUR"
              ? Number(field.value).toLocaleString(
                  field.unit === "PLN" ? "pl-PL" : "de-DE",
                  {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )
              : field.value}
            {field.unit === "PLN" || field.unit === "EUR" ? " " : ""}
            {field.unit}
          </li>
        ))}
    </StyledList>
  );
}
